<template>
	<div class="container trusted-by-carousel">
		<div class="row">
			<div class="col-lg-8 col-md-8 mx-md-auto">
				<swiper
					v-show="isOverflowing"
					:options="swiperOptions"
					class="swiper"
					ref="swiperWithNav"
				>
					<template v-for="(trustedBy, index) in trustedBies">
						<swiper-slide
							:key="index"
							class="trusted-by-carousel__thumb"
							:class="`slide-${index}`"
							:style="{ width: size + 'px', height: size + 'px' }"
						>
							<div class="slide-wrapper">
								<div class="image">
									<a :href="trustedBy.url" class="stretched-link" target="_blank">
										<img loading="lazy" :src="trustedBy.picture" alt=""/>
									</a>
								</div>
							</div>
						</swiper-slide>
					</template>

					<div
						class="swiper-button-prev"
						slot="button-prev"
						id="swiper-prev-trusted-by"
					>
						<svg class="ticon ticon-180">
							<use xlink:href="/images/icons.svg?v1.3#icon-arrow-right"></use>
						</svg>
					</div>
					<div
						class="swiper-button-next"
						slot="button-next"
						id="swiper-next-trusted-by"
					>
						<svg class="ticon">
							<use xlink:href="/images/icons.svg?v1.3#icon-arrow-right"></use>
						</svg>
					</div>
				</swiper>

				<swiper
					v-show="!isOverflowing"
					:options="staticSwiperOptions"
					class="swiper"
					ref="swiperWithoutNav"
				>
					<template v-for="(trustedBy, index) in trustedBies">
						<swiper-slide
							:key="index"
							class="trusted-by-carousel__thumb"
							:class="`slide-${index}`"
							:style="{ width: size + 'px', height: size + 'px' }"
						>
							<div class="slide-wrapper">
								<div class="image">
									<a :href="trustedBy.url" class="stretched-link" target="_blank">
										<img loading="lazy" :src="trustedBy.picture" alt=""/>
									</a>
								</div>
							</div>
						</swiper-slide>
					</template>
				</swiper>
			</div>
		</div>
	</div>
</template>


<script>
import {Swiper, SwiperSlide} from 'vue-awesome-swiper'

export default {
	name: 'TrustedByCarousel',
	components: {
		Swiper,
		SwiperSlide,
	},
	props: {
		trustedBies: Array,
		size: Number,
	},
	data() {
		return {
			isOverflowing: false,
			resizeTimeout: null,
			swiperOptions: {
				loop: true,
				allowTouchMove: true,
				slidesPerView: 'auto',
				slidesPerGroupAuto: true,
				spaceBetween: 30,
				navigation: {
					nextEl: '#swiper-next-trusted-by',
					prevEl: '#swiper-prev-trusted-by',
				},
			},
			staticSwiperOptions: {
				centerInsufficientSlides: true,
				allowTouchMove: false,
				slidesPerView: 'auto',
				slidesPerGroupAuto: true,
				spaceBetween: 30,
				navigation: false,
			},
		}
	},
	mounted() {
		this.debouncedResizeHandler = this.debounce(() => {
			this.isOverflowing = false
			this.checkOverflow()
		}, 200)
		window.addEventListener('resize', this.debouncedResizeHandler)
		this.checkOverflow()
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.debouncedResizeHandler)
	},
	methods: {
		checkOverflow() {
			this.$nextTick(() => {
				const container = this.$refs.swiperWithoutNav?.$el.querySelector('.swiper-wrapper')
				if (!container) return
				this.isOverflowing = container.scrollWidth > container.clientWidth
				console.log(this.isOverflowing);
			})
		},
		debounce(fn, delay) {
			let timeout
			return (...args) => {
				clearTimeout(timeout)
				timeout = setTimeout(() => fn.apply(this, args), delay)
			}
		},
	},
}
</script>


